<!-- 新发基金头部行情部分 -->
<template>
  <div v-if="!$isEmpty(newFundStatus)" class="new-fund-market-header">
    <div class="desc">{{newFundStatus.desc}}</div>
    <div v-if="newFundStatus.statusText !=='募集结束'" class="count-down row">
      <div
        v-for="(item, index) in timeDownArray"
        :key="`count-${index}`"
        class="time-item row">
        <div class="value">{{item.value}}</div>
        <div class="unit">{{item.unit}}</div>
      </div>
    </div>
    <div v-if="newFundStatus.status !== 'error'">
      <div v-if="newFundStatus.status !== 'end'" class="buy-desc">认购期</div>
      <div v-if="newFundStatus.statusText ==='募集结束'" class="wait-publish">等待成立</div>
      <div v-if="newFundStatus.status !== 'end'" class="date">{{buyDate}}</div>
    </div>
  </div>
</template>

<script>
import { throttle } from '@fund/basic-lib/dist/lib/function';
import tool from '@/utils/tool';

export default {
  name: 'new-fund-market-header',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    newFundStatus: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      timerId: undefined, // 定时器id
      timeDownArray: [
        {
          value: '--',
          unit: '天',
        },
        {
          value: '--',
          unit: '时',
        },
        {
          value: '--',
          unit: '分',
        },
        {
          value: '--',
          unit: '秒',
        },
      ], // 倒计时数组
    };
  },

  computed: {
    buyDate() {
      const { startTime, endTime } = this.basicInfo;
      if (this.$isEmpty(startTime) || this.$isEmpty(endTime)) return '';
      const start = startTime.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5');
      const end = endTime.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5');
      return `${start}~${end}`;
    },
  },

  watch: {
    newFundStatus: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.$isEmpty(this.newFundStatus)) {
          const { startTime, endTime } = this.basicInfo;
          const start = new Date(startTime.replace(/-/g, '/')).getTime();
          const end = new Date(endTime.replace(/-/g, '/')).getTime();
          const now = new Date().getTime();
          if (start - now > 0) {
            this.countDown(start, 'start');
          } else if (start - now <= 0 && end - now >= 0) {
            this.countDown(end, 'end');
          }
        }
      },
    },
  },

  methods: {
    // 倒计时
    countDown(time, status = 'start') {
      console.log('倒计时', time, status);
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        const res = tool.formatTime(time);

        // 倒计时清零 需要重新倒计时 或者结束倒计时
        if (res.isFinishCountDown) {
          // 募集结束 通知页面重刷接口 通过数据修改头部 底部按钮状态
          // 清空计时器
          throttle(() => {
            clearInterval(this.timerId);
            this.$layout.start();
          }, 1000, { leading: true })();
        }
        this.timeDownArray = res.timeDownArray;
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}
.new-fund-market-header {
  padding: 10px 0 13px 0;
  width: 100%;
  box-sizing: border-box;
  .desc {
    font-size: 26px;
    color: #999999;
  }
  .count-down {
    align-items: baseline;
    .time-item {
      align-items: baseline;
      .value {
        font-family: DINAlternate-Bold;
        font-size: 66px;
        color: #000000;
        text-align: center;
      }
      .unit {
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #999999;
        text-align: justify;
        margin-left: 16px;
        margin-right: 16px;
      }
    }
  }
  .buy-desc {
    font-size: 26px;
    margin-top: 11px;
    color: #999999;
  }
  .wait-publish {
    font-size: 56px;
    color: #000000;
    margin-top: 15px;
  }
  .date {
    font-family: DINAlternate-Regular;
    font-size: 32px;
    color: #000000;
    margin-top: 8px;
  }
}
</style>
